import { render, staticRenderFns } from "./KelasLMS.vue?vue&type=template&id=c037dea2"
import script from "./KelasLMS.vue?vue&type=script&lang=js"
export * from "./KelasLMS.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports